export const getApiErrorMessage = (error, fallback = 'Ocurrió un error') => {
  const detail = error?.response?.data?.detail;

  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (typeof item === 'string') return item;
        if (!item || typeof item !== 'object') return String(item || '');

        const location = Array.isArray(item.loc)
          ? item.loc
              .filter((part) => !['body', 'query', 'path'].includes(String(part)))
              .join('.')
          : '';
        const message = typeof item.msg === 'string' ? item.msg : '';
        return location && message ? `${location}: ${message}` : message || location;
      })
      .filter(Boolean);

    return messages.length ? messages.join(' · ') : fallback;
  }

  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') {
    return typeof detail.msg === 'string' ? detail.msg : fallback;
  }

  return error?.message || fallback;
};
